module.exports = "<iframe frameborder=\"0\" allowfullscreen width=\"100%\" height=\"100%\" src=\"{{ url }}\"></iframe>\n"